module.exports = __webpack_public_path__ + "static/media/rede-protecao-7.65106c45.jpeg";